import classNames from 'classnames';
import { isArray } from 'lodash-es';
import { type ValidateResult } from 'react-hook-form';

import Alert from '@/components/ui/alerts/Alert';

import styles from './ErrorList.module.scss';

type Color = 'warning' | 'danger';

interface Props {
  errors:
    | null
    | undefined
    | ValidateResult[]
    | React.ReactElement[]
    | (string | React.ReactElement)[];
  color?: Color;
  'aria-label'?: string;
  className?: string;
}

const ErrorList = ({
  errors,
  color = 'danger',
  'aria-label': ariaLabel,
  className,
}: Props) => {
  if (!(errors && errors.length > 0)) return null;
  return (
    <div className={classNames(styles.wrapper, className)}>
      <Alert color={color} aria-label={ariaLabel}>
        <ul className={styles.list}>
          {(errors as string[]).map((error) =>
            isArray(error) ? (
              (error as string[]).map((err) => (
                <li key={err} data-testid="errorItem">
                  {err}
                </li>
              ))
            ) : (
              <li key={error} data-testid="errorItem">
                {error}
              </li>
            ),
          )}
        </ul>
      </Alert>
    </div>
  );
};

export default ErrorList;
